<!-- Start if already created project view submission form show this div section -->
<form [formGroup]="form">
  @if (data) {
    <div class="r-company-wrapper" formGroupName="companyInfo">
      <mat-accordion>
        <mat-expansion-panel (opened)="onCompanyPanelOpened()" (closed)="onCompanyPanelClosed()" [expanded]="panelOpen || companyPanelOpenState">
          <mat-expansion-panel-header class="header-panel">
            <mat-panel-title class="title-panel">
              <h2>Company Information</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="panel-container two-column">
            <div class="item" >
              @if (shouldShowCheckbox()) {
                <mat-checkbox color="primary" formControlName="companyName"> </mat-checkbox>
              }
              <div class="text">
                <div class="label">Company Name</div>
                <div class="name" [style.color]="form.get('companyInfo.companyName')?.value ? '#d33' : 'inherit'">{{ data.name }}</div>
              </div>
            </div>
            <div class="item">
              @if (shouldShowCheckbox()) {
                <mat-checkbox color="primary" formControlName="companyContactName"> </mat-checkbox>
              }
              <div class="text">
                <div class="label">Contact Name</div>
                <div class="name" [style.color]="form.get('companyInfo.companyContactName')?.value ? '#d33' : 'inherit'">{{ data.contactName }}</div>
              </div>
            </div>
            <div class="item">
              @if (shouldShowCheckbox()) {
                <mat-checkbox color="primary" formControlName="companyEmail"> </mat-checkbox>
              }
              <div class="text">
                <div class="label">Contact Email</div>
                <div class="name" [style.color]="form.get('companyInfo.companyEmail')?.value ? '#d33' : 'inherit'">{{ data.emails }}</div>
              </div>
            </div>
            <div class="item">
              @if (shouldShowCheckbox()) {
                <mat-checkbox color="primary" formControlName="companyAddress"> </mat-checkbox>
              }
              <div class="text">
                <div class="label">Address</div>
                <div class="name" [style.color]="form.get('companyInfo.companyAddress')?.value ? '#d33' : 'inherit'">{{ data.streetAddress }}</div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }

  @if (data) {
    <div class="r-company-wrapper billing-section">
      <div class="row">
        <div class="col-md-6 section-align" formGroupName="billingInfo">
          <mat-accordion>
            <mat-expansion-panel (opened)="onPanelBillOpened()" (closed)="onPanelBillClosed()" [expanded]="panelOpen || panelOpenBillState" >
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title class="title-panel">
                  <h2>Billing/Reporting Information</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-container two-column">
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="billingName"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Company Name</div>
                    <div class="name" [style.color]="form.get('billingInfo.billingName')?.value ? '#d33' : 'inherit'">{{ billing.invoice }}</div>
                  </div>
                </div>
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="billingContactName"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Contact Name</div>
                    <div class="name" [style.color]="form.get('billingInfo.billingContactName')?.value ? '#d33' : 'inherit'">{{ billing.contactName }}</div>
                  </div>
                </div>
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="billingEmail"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Contact Email - Reports Submittal</div>
                    <div class="name" [style.color]="form.get('billingInfo.billingEmail')?.value ? '#d33' : 'inherit'">{{ billing.contactEmail }}</div>
                  </div>
                </div>
                <div class="item new-row">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="billingAddress"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Address</div>
                    <div class="name" [style.color]="form.get('billingInfo.billingAddress')?.value ? '#d33' : 'inherit'">{{ billing.streetAddress }}</div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="col-md-6 section-align" formGroupName="projectInfo">
          <mat-accordion>
            <mat-expansion-panel (opened)="onPanelOpened()" (closed)="onPanelClosed()" [expanded]="panelOpen || panelOpenState">
              <mat-expansion-panel-header class="header-panel">
                <mat-panel-title class="title-panel">
                  <h2>Project Information</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-container two-column">
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="projectName"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Project Name</div>
                    <div class="name" [style.color]="form.get('projectInfo.projectName')?.value ? '#d33' : 'inherit'">{{ data.projectName }}</div>
                  </div>
                </div>
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="projectLocation"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Project Location</div>
                    <div class="name" [style.color]="form.get('projectInfo.projectLocation')?.value ? '#d33' : 'inherit'">{{ data.projectLocation }}</div>
                  </div>
                </div>
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="projectNumber"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">Project Number</div>
                    <div class="name" [style.color]="form.get('projectInfo.projectNumber')?.value ? '#d33' : 'inherit'">{{ data.projectNumber }}</div>
                  </div>
                </div>
                <div class="item">
                  @if (shouldShowCheckbox()) {
                    <mat-checkbox color="primary" formControlName="projectJobNo"> </mat-checkbox>
                  }
                  <div class="text">
                    <div class="label">PO/Job Number</div>
                    <div class="name" [style.color]="form.get('projectInfo.projectJobNo')?.value ? '#d33' : 'inherit'">{{ data.jobNumber }}</div>
                  </div>
                </div>
                @if (officeLocationName) {
                  <div class="item">
                    <div class="text">
                      <div class="label">Office Location</div>
                      <div class="name">{{ officeLocationName }}</div>
                    </div>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  }
</form>
<!-- Start if already created project view submission form show this div section -->
